import { render, staticRenderFns } from "./Down.vue?vue&type=template&id=5de34204"
import script from "./Down.vue?vue&type=script&lang=js"
export * from "./Down.vue?vue&type=script&lang=js"
import style0 from "./Down.vue?vue&type=style&index=0&id=5de34204&prod&lang=scss"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports